<div class="flex items-center justify-between">
  <h1
    class="pb-5 font-brand text-28px font-bold text-neutral-800"
    translate="como.create-or-link-account.otp-step.title"
  ></h1>
  <app-rounded-icon-button
    icon="icon-cross"
    (onClick)="onClose.emit($event)"
  ></app-rounded-icon-button>
</div>

<form [formGroup]="form">
  <label
    for="comoRegistrationOtpInput"
    class="mb-1 block font-base text-sm font-normal leading-5 text-neutral-600"
    translate="como.link-account.enter-auth-code"
  ></label>
  <input
    id="comoRegistrationOtpInput"
    type="text"
    formControlName="authCode"
    (keyup.enter)="onSubmit($event)"
    class="flex w-full border border-solid border-neutral-300 bg-neutral-50 px-5 py-8xs font-base text-base font-normal leading-5"
    [class.border-error-700]="
      form.controls?.authCode?.errors &&
      (form.controls?.authCode?.dirty || form.controls?.authCode?.touched)
    "
  />

  <div class="hidden kiosk:block">
    <app-numeric-keypad-atom
      (numberClick)="onKeypadNumberClick($event)"
      (deleteClick)="onKeypadDeleteClick()"
    ></app-numeric-keypad-atom>
  </div>

  <div
    class="mt-2 font-base text-xs font-normal text-error-700"
    *ngIf="
      form.controls?.authCode?.invalid &&
      (form.controls?.authCode?.dirty || form.controls?.authCode?.touched)
    "
    translate="como.link-account.errors.invalid-auth-code"
  ></div>
  <div
    class="mt-2 font-base text-xs font-normal text-error-700"
    *ngIf="errorMessage"
    [translate]="errorMessage"
  ></div>
</form>

<div class="mt-10 flex flex-wrap xm:flex-nowrap">
  <div class="w-full xm:w-1/2 xm:pr-1">
    <app-button-atom
      size="L"
      [label]="'como.register.otp.back-button' | translate"
      type="light"
      (click)="onGoToPreviousStep()"
      [full]="true"
    ></app-button-atom>
  </div>
  <div class="w-full pt-2 xm:w-1/2 xm:pl-1 xm:pt-0">
    <app-button-atom
      size="L"
      [label]="'como.register.otp.continue-button' | translate"
      type="primary"
      [full]="true"
      [iconUrl]="isValidating ? 'assets/images/spinner.svg' : ''"
      [disabled]="isValidating || !form.valid"
      (click)="onSubmit($event)"
    ></app-button-atom>
  </div>
</div>
